import { JSX } from "react";

import { Outlet } from "react-router-dom";

function StationRegionDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default StationRegionDashboardPage;
